export const styles = {
  FILTER_FIELD_STYLE: {
    width: 160,
    minWidth: 160,
    margin: '0 30px 0 0',
  },
  textInputContainer: {
    display: 'flex',
    gap: 10,
    flexWrap: 'wrap',
  },
}

export default styles
